import { render, staticRenderFns } from "./AutoResizeTextarea.vue?vue&type=template&id=1f8529b0&scoped=true&"
import script from "./AutoResizeTextarea.vue?vue&type=script&lang=js&"
export * from "./AutoResizeTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AutoResizeTextarea.vue?vue&type=style&index=0&id=1f8529b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8529b0",
  null
  
)

export default component.exports